import { configureStore as configureToolkitStore } from '@reduxjs/toolkit';
import { apiEndpoint, getZaplifySdk } from '@zaplify/sdk';
import { TypedUseSelectorHook, useSelector } from 'react-redux-latest';
import socketMiddleware from '../middleware/socketMiddleware';
import rootReducer from '../reducers';

let store;

export default function configureStore(initialState: any) {
    const services = {
        zaplifySdk: getZaplifySdk(apiEndpoint, initialState.msal),
    };
    const extraMiddleWare = getMiddlewares(initialState);

    store = configureToolkitStore({
        reducer: rootReducer,
        preloadedState: initialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: {
                    extraArgument: services,
                },
                serializableCheck: {
                    ignoredActionPaths: ['auth', 'socketClient'], // replace the left to my path
                    ignoredPaths: ['socketClient', 'statistics.dateFrom', 'statistics.dateTo'],
                },
                immutableCheck: {
                    ignoredPaths: ['socketClient'],
                },
            }).concat(extraMiddleWare),
    });
    return store;
}

export type RootState = ReturnType<typeof rootReducer>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type AppDispatch = typeof store.dispatch;

function getMiddlewares(initialState) {
    return [socketMiddleware(initialState.socketClient)];
}
